export var G="#C9A84C", D="#0D0D0D", D2="#111", D3="#1A1A1A", D4="#222", BR="#2A2A2A", TX="#F0F0F0", T2="#A0A0A0";

export var PILARES = [
  { key:"alimentacao", label:"Alimentação", icon:"🥗", perguntas:[
    {t:"Com que frequência você segue um plano alimentar estruturado?",p:2},
    {t:"Você controla o tamanho das suas porções?",p:2},
    {t:"Quantas refeições você faz por dia (ideal: 3–5)?",p:1.5},
    {t:"Você evita ultraprocessados regularmente?",p:1.5},
    {t:"Sua hidratação diária é adequada (2L+)?",p:1},
  ]},
  { key:"treino", label:"Treino", icon:"🏋️", perguntas:[
    {t:"Você treina com frequência regular (3x+ por semana)?",p:2},
    {t:"Você tem progressão nos seus treinos?",p:2},
    {t:"Você combina musculação e cardio?",p:1.5},
    {t:"Você se aquece e alonga adequadamente?",p:1},
    {t:"Seus treinos duram entre 45–75 minutos?",p:1.5},
  ]},
  { key:"sono", label:"Sono", icon:"🌙", perguntas:[
    {t:"Você dorme entre 7–9 horas por noite?",p:2.5},
    {t:"Seu sono é contínuo e reparador?",p:2},
    {t:"Você mantém horários regulares de dormir/acordar?",p:2},
    {t:"Você evita telas 30min antes de dormir?",p:1.5},
  ]},
  { key:"estresse", label:"Estresse", icon:"🧘", perguntas:[
    {t:"Seu nível de estresse é baixo ou controlado?",p:2},
    {t:"Você tem práticas de gestão do estresse?",p:2},
    {t:"O estresse não compromete seus hábitos alimentares?",p:2},
    {t:"Você tem tempo de qualidade para si semanalmente?",p:2},
  ]},
  { key:"consistencia", label:"Consistência", icon:"📅", perguntas:[
    {t:"Você mantém sua rotina mesmo em dias difíceis?",p:2.5},
    {t:"Você está há mais de 30 dias no processo?",p:2},
    {t:"Você registra sua evolução (peso, medidas)?",p:2},
    {t:"Você raramente desiste ou recomeça do zero?",p:1.5},
  ]},
  { key:"comportamento", label:"Comportamento", icon:"🧠", perguntas:[
    {t:"Você tem uma relação saudável com a comida?",p:2},
    {t:"Você come por fome real, não por ansiedade?",p:2},
    {t:"Você tem metas claras e motivação definida?",p:2},
    {t:"Você busca aprendizado constante sobre saúde?",p:2},
  ]},
];
